import * as axios from "axios";
import { getToken } from "../utils/localstorage.utils";

export default class InvitionApis {
  constructor() {
    this.api_token = null;
    this.client = null;
    this.api_url = import.meta.env.VITE_APP_API_URL;
  }

  init = () => {
    this.api_token = getToken();
    let headers = {
      Accept: "application/json",
    };
    if (this.api_token) {
      headers.Authorization = this.api_token;
    }
    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
    });
    return this.client;
  };

  getInviteWebUrl = (type, data) => {
    return this.init().post(`/private/api/v1/${type}/${data?.contextId}/generateInviteLink`, data);
  };

  getCheckInviteDetails = (type, data) => {
    return this.init().post(`private/api/v1/${type}/${data.inviteId}/checkInviteLink`, data);
  };
}
